import React from 'react';
import { Row, Col, Card, Tag, Space, Typography } from 'antd';
import { mockGapsData } from '../data/mockData';

const { Text } = Typography;

const GapsAnalysisTab: React.FC = () => {
  const getTagColor = (status: string) => {
    switch (status) {
      case 'danger': return 'red';
      case 'warning': return 'orange';
      case 'success': return 'green';
      default: return 'default';
    }
  };

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Coverage Gaps" size="small">
          <Space direction="vertical" style={{ width: '100%' }}>
            <div>
              <Text strong>Under-represented Muscle Groups:</Text>
              <div style={{ marginTop: 8 }}>
                {mockGapsData.underRepresentedMuscleGroups.map((item, index) => (
                  <Tag key={index} color={getTagColor(item.status)}>
                    {item.name} ({item.exercises} exercises)
                  </Tag>
                ))}
              </div>
            </div>
            
            <div>
              <Text strong>Missing Equipment Categories:</Text>
              <div style={{ marginTop: 8 }}>
                {mockGapsData.missingEquipmentCategories.map((item, index) => (
                  <Tag key={index} color={getTagColor(item.status)}>
                    {item.name}
                  </Tag>
                ))}
              </div>
            </div>
            
            <div>
              <Text strong>Adaptation Gaps:</Text>
              <div style={{ marginTop: 8 }}>
                {mockGapsData.adaptationGaps.map((item, index) => (
                  <Tag key={index} color={getTagColor(item.status)}>
                    {item.name} ({item.coverage}% coverage)
                  </Tag>
                ))}
              </div>
            </div>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default GapsAnalysisTab; 